import { fontType } from 'shared/styles/functions'
import styled from 'styled-components'

export const GraphContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 420px;
	${fontType(0)}
`
